import {
  Component,
  ChangeDetectionStrategy,
  HostBinding,
  Input,
} from '@angular/core';
import { IAccount, MarketplacePermission } from '@libs/authentication/services';

@Component({
  selector: 'account-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-center">
      <saj-avatar
        class="!w-[32px] !h-[32px] ui-strong-sm text-purple-500 bg-purple-200"
        [ngClass]="{ 'mr-12 group-hover:bg-purple-300': !isCollapsed }"
        [size]="'medium'"
        [name]="user | avatarName">
      </saj-avatar>
      <div class="text-left" [hidden]="isCollapsed">
        <p class="ui-strong-md mb-4 text-gray-900 h-[20px]">
          {{ user | avatarName | truncate: 18 }}
        </p>
        <p class="ui-sm text-gray-700 h-16">
          {{ account?.name | truncate: 22 }}
        </p>
      </div>
    </div>

    <saj-icon-overflow
      class="h-16 w-16 text-gray-900"
      [ngClass]="{ '!hidden': isCollapsed }"></saj-icon-overflow>
  `,
})
export class AccountInfoComponent {
  @HostBinding() get classList() {
    let classes =
      'flex items-center p-12 w-full rounded-[32px] bg-white cursor-pointer';
    classes += this.isCollapsed
      ? ' justify-center'
      : ' justify-between group hover:bg-purple-100';
    return classes;
  }

  @Input() user: MarketplacePermission;
  @Input() account: IAccount;
  @Input() isCollapsed: boolean;
}
